import { clientEnv } from '@/env/client';

export const ROUTE_SUBSCRIPTION_HOME = '/abbonamenti';
export const makePrestazioneRoute = (city: string, speciality: string) => `/prenota-visita/${speciality}/${city}`;
export const makePrestazioneRouteWithoutCity = (speciality: string) => `/prenota-visita/${speciality}`;
export const DAVINCI_CDN = clientEnv.NEXT_PUBLIC_DAVINCI_ASSETS_CDN;
export const ROUTE_TERMS_CONDITIONS = '/termini-e-condizioni-del-servizio';
export const DAVINCI_WEBAPP_FORGOT_PASSWORD = `${clientEnv.NEXT_PUBLIC_DAVINCI_WEBAPP_BASE_URL}/login/forgotPassword`;
export const ELTY_SITE_URL = clientEnv.ELTY_PUBLIC_URL;
